import { render, staticRenderFns } from "./ArchiveViewer.vue?vue&type=template&id=4b55adb9"
import script from "./ArchiveViewer.vue?vue&type=script&lang=js"
export * from "./ArchiveViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports